const CIRCUMFERENCE = 282.74;

const clampPercentage = (value) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return 0;
  }
  return Math.max(0, Math.min(100, Math.round(numericValue)));
};

const resolveRingColor = (percent) => {
  if (percent < 33) {
    return '#d83933';
  }
  if (percent < 100) {
    return '#005ea2';
  }
  return '#00a91c';
};

const ProfileCompletionRadial = ({ percent = 0, label = 'Profile completion' }) => {
  const normalizedPercent = clampPercentage(percent);
  const offset = CIRCUMFERENCE - (normalizedPercent / 100) * CIRCUMFERENCE;
  const ringColor = resolveRingColor(normalizedPercent);

  return (
    <div className="profile-completion">
      <div
        className="usa-radial-progress"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={normalizedPercent}
      >
        <svg className="usa-radial-progress__svg" viewBox="0 0 100 100" aria-hidden="true">
          <circle className="usa-radial-progress__track" cx="50" cy="50" r="45" />
          <circle
            className="usa-radial-progress__ring"
            cx="50"
            cy="50"
            r="45"
            style={{
              strokeDashoffset: offset,
              stroke: ringColor,
            }}
          />
        </svg>
        <span className="usa-radial-progress__text">{`${normalizedPercent}%`}</span>
      </div>
    </div>
  );
};

export default ProfileCompletionRadial;
